import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import { Dispatch } from "redux";
import {
    setIsAtQualification,
    setIsCreateCertificateModalOpen,
    setSelectedQualification,
} from "../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { TableWidgetRow } from "@hatch-digital-nl/abs-storybook/legacy";

interface Args {
    missingQualifications?: QualificationInterface[];
    dispatch: Dispatch;
}

export const mapMissingQualificationsToRows = (
    args: Args,
): TableWidgetRow[] => {
    const { dispatch, missingQualifications } = args;

    if (!missingQualifications) {
        return [];
    }

    return missingQualifications.map((qualification) => {
        return [
            {
                value: qualification.name,
            },
            {
                value: qualification.qualification_standards
                    .map((standard) => standard.name)
                    .join(", "),
            },
            {
                value: "Toevoegen",
                onClick: () => {
                    dispatch(setSelectedQualification(qualification));
                    dispatch(setIsCreateCertificateModalOpen(true));
                    dispatch(setIsAtQualification(true));
                },
            },
        ];
    });
};
